import { ReactNode } from "react";
import { theme } from "antd";

interface FooterProps {
  children: ReactNode;
  className?: string;
}

export function Footer({ children, className }: FooterProps) {
  const { token } = theme.useToken();

  return (
    <div
      className={className}
      style={{
        padding: `${token.paddingXS}px ${token.paddingLG}px`,
        borderTop: `1px solid ${token.colorBorderSecondary}`,
        background: token.colorFillQuaternary,
      }}
    >
      {children}
    </div>
  );
}
